"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const cosmos_1 = require("components/cosmos");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const Html_1 = __importDefault(require("components/Html"));
const translationContext_1 = require("configs/translationContext");
const Currency_1 = __importDefault(require("helpers/Currency"));
const services_1 = require("modules/app/services");
const clickFreeModuleSalesConfigSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleSalesConfigSchema");
const clickFreeModuleSalesDefaultSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleSalesDefaultSchema");
const viewFreeModuleModalSchema_1 = require("modules/app/services/datahubEvents/freeModule/viewFreeModuleModalSchema");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const SalesService_1 = __importDefault(require("modules/salesManager/SalesService"));
const configure_sales_page_svg_1 = __importDefault(require("./assets/configure-sales-page.svg"));
const signUpModal_1 = require("./signUpModal");
const ConfigureSalesPage = ({ onEnableFreeModule, mainOffer, onNextStep }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { t } = (0, translationContext_1.useTranslation)();
    const subdomain = MembershipService_1.default.subdomain;
    const offerCurrency = mainOffer &&
        Currency_1.default.formatCurrencySymbol(mainOffer.price, mainOffer.currencyCode);
    const savePageWithDefaultOffer = async () => {
        const schema = new clickFreeModuleSalesDefaultSchema_1.ClickFreeModuleSalesDefaultSchema();
        const salesPageConfig = {
            allowSignup: true,
            offers: (mainOffer === null || mainOffer === void 0 ? void 0 : mainOffer.offerKey) ? [{ offerKey: mainOffer.offerKey }] : []
        };
        services_1.DatahubEventsService.sendEvent({ schema });
        setIsLoading(true);
        await SalesService_1.default.saveFreeSignup(salesPageConfig, subdomain);
        onEnableFreeModule();
    };
    const handleNextStep = () => {
        const schema = new clickFreeModuleSalesConfigSchema_1.ClickFreeModuleSalesConfigSchema();
        services_1.DatahubEventsService.sendEvent({ schema });
        onNextStep();
    };
    (0, react_1.useEffect)(() => {
        const schema = new viewFreeModuleModalSchema_1.ViewFreeModuleModalSchema({
            step: signUpModal_1.ViewFreeModuleSteps.SALES_PAGE_CONFIG
        });
        services_1.DatahubEventsService.sendEvent({ schema });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, {}), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: "_d-flex _align-items-center _flex-column", children: [(0, jsx_runtime_1.jsx)("img", { src: configure_sales_page_svg_1.default, className: "", alt: "" }), (0, jsx_runtime_1.jsxs)("div", { className: "_text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "_text-4 _mt-4 _text-gray-900", children: t('module_editor.active_free_signup.step2.title') }), (0, jsx_runtime_1.jsx)("div", { className: "_text-2 _text-gray-500 _mt-4", children: (0, jsx_runtime_1.jsx)(Html_1.default, { children: t('module_editor.active_free_signup.step2.subtitle') }) }), (0, jsx_runtime_1.jsxs)(cosmos_1.Alert, { type: "success", className: "_d-flex _align-items-center _mt-4", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'circle-dollar'], className: "_mr-2" }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-start _flex-column _text-justify", children: [(0, jsx_runtime_1.jsx)("div", { className: "_font-weight-bold", children: t('module_editor.active_free_signup.step2.alert_title') }), (0, jsx_runtime_1.jsx)("div", { children: t('module_editor.active_free_signup.step2.alert_description') })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _w-full", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", className: "_mt-2", onClick: handleNextStep, disabled: isLoading, children: t('module_editor.active_free_signup.step2.personalize_page') }), offerCurrency && ((0, jsx_runtime_1.jsx)(button_1.default, { variation: "tertiary", className: "_mt-2", onClick: () => savePageWithDefaultOffer(), disabled: isLoading, children: t('module_editor.active_free_signup.step2.default_offer', {
                                    data: {
                                        preço: offerCurrency
                                    }
                                }) }))] })] })] }));
};
exports.default = ConfigureSalesPage;
